import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'image-item',
  props: {
  zoom: {
    type: Number,
    default: 1,
  },
  rotate: {
    type: Number,
    default: 0,
  },
  translateX: {
    type: Number,
    default: 0,
  },
  translateY: {
    type: Number,
    default: 0,
  },
  src: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props



return { __sfc: true,props }
}

})